// src/pages/jewellers/CustomerKittyView.js
import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "../../api";
import Loader from "../../components/Loader";

export default function CustomerKittyView() {
  const { id } = useParams();
  const [kitty, setKitty] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/customer-kitties/view/${id}`).then((res) => {
      setKitty(res.data.data || res.data);
      setLoading(false);
    });
  }, [id]);

  if (loading) return <Loader />;
  if (!kitty) return <p className="text-center text-gray-600 mt-8">Kitty not found.</p>;

  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h1 className="text-3xl font-bold mb-6 text-purple-700 text-center">
        Customer Kitty Details
      </h1>

      <div className="bg-white/90 backdrop-blur-md border border-purple-100 p-6 rounded-2xl shadow-lg transition-all duration-300 hover:shadow-xl">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <Detail label="Kitty Name" value={kitty.kitty_name} icon="💎" />
          <Detail label="Customer" value={kitty.customer?.full_name || "N/A"} icon="👤" />
          <Detail label="Type" value={kitty.kitty_type} icon="📦" />
          <Detail label="Target Amount" value={`₹${kitty.target_amount}`} icon="🎯" />
          <Detail label="Collected" value={`₹${kitty.collected_amount}`} icon="💰" />
          <Detail label="Status" value={kitty.status} icon="📋" />
          <Detail label="Start Date" value={kitty.start_date} icon="📅" />
          <Detail label="End Date" value={kitty.end_date} icon="⏰" />
          <Detail label="Token Number" value={kitty.token_number || "N/A"} icon="🎟️" />
        </div>

        {kitty.notes && (
          <div className="mt-6 border-t pt-4">
            <h3 className="font-semibold text-gray-800 mb-1 flex items-center gap-2">
              📝 <span>Notes</span>
            </h3>
            <p className="text-gray-600">{kitty.notes}</p>
          </div>
        )}
      </div>

      <div className="mt-6 flex justify-center">
        <Link
          to={`/jewellers/customer-kitties/${id}/edit`}
          className="inline-block bg-gradient-to-r from-purple-500 to-purple-600 text-white px-6 py-2.5 rounded-xl font-medium shadow hover:scale-105 hover:shadow-lg transition-transform duration-200"
        >
          ✏️ Edit Kitty
        </Link>
      </div>
    </div>
  );
}

// ✅ Reusable small component
function Detail({ label, value, icon }) {
  return (
    <div className="flex items-center bg-purple-50/60 p-3 rounded-lg hover:bg-purple-100 transition-colors duration-200">
      <span className="text-lg mr-3">{icon}</span>
      <div>
        <p className="text-sm text-gray-500">{label}</p>
        <p className="font-semibold text-gray-800">{value}</p>
      </div>
    </div>
  );
}
